export default "__VITE_ASSET__823fd69f__"